import {
    SHOPS_REQUEST_START,
    SHOPS_REQUEST_SUCCESS,
    SHOPS_REQUEST_FAIL,
    SHOP_BY_ID_REQUEST_START,
    SHOP_BY_ID_REQUEST_SUCCESS,
    SHOP_BY_ID_REQUEST_FAIL,
    SHOPS_CLEAR_DATA,
    SHOPS_RELOAD_SHOP,
    SHOPS_RELOAD_SHOP_START,
    SHOPS_RELOAD_SHOP_FAIL,
    SHOPS_SELECT_SHOP,
    LOAD_ACTIVE_SHOP_ADMINISTRATORS_REQUEST_SUCCESS,
    LOAD_ACTIVE_SHOP_ADMINISTRATORS_REQUEST_FAIL,
    UPDATE_CURRENT_SHOP_ADMINISTRATOR, SHOPS_SET_ACTIVE_SHOP_SIMPLE_CHAT,
    UPDATE_NAME_SHOP_ADMINISTRATOR_FAIL,
    TOUCH_UPDATE_NAME_SHOP_ADMINISTRATOR_FORM,
} from '../actions/Shops'


const defaultState = {
    activeShop: undefined,
    activeShopAdministrators: undefined,
    currentShopAdministrator: undefined,
    shops: undefined,
    isSendingRequest: false,
    shopsAreInitiallyLoaded: false,
};

export default function reducer(state = defaultState, action) {
    switch (action.type) {
        case SHOPS_REQUEST_START:
            return {
                ...state,
                isSendingRequest: action.setRequestSending,
            }

        case SHOP_BY_ID_REQUEST_START:
            return {
                ...state,
                isSendingRequest: true,
            }

        case SHOPS_REQUEST_FAIL:
        case SHOP_BY_ID_REQUEST_FAIL:
            return {
                ...state,
                isSendingRequest: false,
            }

        case SHOPS_REQUEST_SUCCESS:
            return {
                ...state,
                shops: action.shops,
                shopsAreInitiallyLoaded: true,
                isSendingRequest: false,
            };

        case SHOP_BY_ID_REQUEST_SUCCESS:
            return {
                ...state,
                shops: [action.shop],
                shopsAreInitiallyLoaded: true,
                isSendingRequest: false,
            };

        case SHOPS_CLEAR_DATA:
            return {...defaultState, ...action.data};

        case SHOPS_RELOAD_SHOP:
            return {
                ...state,
                activeShop: action.shop,
            };

        case SHOPS_SELECT_SHOP:
            return {
                ...state,
                activeShop: action.shop,
            };
        case SHOPS_SET_ACTIVE_SHOP_SIMPLE_CHAT:
            const newShop = {...state.activeShop, simple_chat: action.setTo};
            return {
                ...state,
                activeShop: newShop,
            };

        case LOAD_ACTIVE_SHOP_ADMINISTRATORS_REQUEST_SUCCESS:
            return {
                ...state,
                activeShopAdministrators: action.shopAdministrators,
            };

        case LOAD_ACTIVE_SHOP_ADMINISTRATORS_REQUEST_FAIL:
            return {
                ...state,
                activeShopAdministrators: undefined,
            };

        case UPDATE_CURRENT_SHOP_ADMINISTRATOR:
            return {
                ...state,
                currentShopAdministrator: action.currentShopAdministrator,
            };

        case UPDATE_NAME_SHOP_ADMINISTRATOR_FAIL:
            return {
                ...state,
                updateNameShopAdministratorError: action.errors
            };

        case TOUCH_UPDATE_NAME_SHOP_ADMINISTRATOR_FORM:
            return {
                ...state,
                updateNameShopAdministratorError: {}
            };
    }
    return state;
}
